<template>
    <div class="widget-wallet-item">
        <ui-address v-bind:address="address"/>
        <div class="widget-wallet-data">
            <icon-gram v-once class="widget-wallet-icon"/>
            <div class="widget-wallet-balance">
                {{ formattedBalance }}
            </div>
        </div>
    </div>
</template>

<script>
import { MULTIPLIER } from '~/helpers';
import IconGram from '@img/icons/tonscan/gram-diamond.svg?vue';

export default {
    props: {
        address: String,
        balance: String,
    },

    computed: {
        formattedBalance() {
            return (Math.round(this.balance / MULTIPLIER)).toLocaleString();
        },
    },

    components: {
        IconGram,
    },
};
</script>
